import { MDBContainer } from 'mdbreact';
import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';

import LoginCard from '../Components/LoginCard';
import { UserContext } from '../Components/UserContext';

import './PortalHome.css';

export default function PortalHome(props) {
  // This userInfo object will have everything from the context
  const userContext = useContext(UserContext);
  if (userContext.name !== '') {
    return <Redirect to="/profile" />;
  }

  return (
    <>
      <MDBContainer
        className="backgroundContainer"
        fluid
        style={{
          display: 'flex',
          flexGrow: 1,
          paddingLeft: '0',
          paddingRight: '0',
        }}
      >
        <MDBContainer
          className="rgba-stylish-slight"
          fluid
          style={{
            flexGrow: 1,
            paddingLeft: '0',
            paddingRight: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <LoginCard style={{}} baseURL={props.baseURL} />
        </MDBContainer>
      </MDBContainer>
      <div style={{ position: 'absolute', bottom: '0px', height: '0px' }} />
    </>
  );
}
